import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownRight } from 'lucide-react';
import { RotatingSquare, FloatingTriangle, ParallaxCircle, GridBackground } from './GeometricShapes';
export function Hero() {
  return <section className="relative min-h-screen w-full overflow-hidden flex flex-col justify-center px-6 md:px-12 pt-20 border-b-2 border-navy" data-id="element-138">
      <GridBackground data-id="element-139" />

      {/* Geometric Decorations */}
      <RotatingSquare color="coral" size={120} className="top-1/4 right-[15%] opacity-90 mix-blend-multiply" data-id="element-140" />
      <FloatingTriangle color="navy" size={180} className="bottom-1/4 left-[10%] opacity-80" data-id="element-141" />
      <ParallaxCircle color="coral" size={60} className="top-[15%] left-[20%]" speed={2} data-id="element-142" />

      <div className="max-w-7xl mx-auto w-full relative z-10" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-144">
          <h2 className="font-mono text-coral text-sm md:text-base tracking-widest mb-4 uppercase" data-id="element-145">
            Swiss-Inspired AI Branding
          </h2>

          <h1 className="text-[12vw] leading-[0.85] font-bold tracking-tighter text-navy mb-8 mix-blend-darken" data-id="element-146">
            COFFRE
            <br data-id="element-147" />
            TRESOR
          </h1>

          <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-12 border-t-2 border-navy pt-8" data-id="element-148">
            <div className="max-w-xl" data-id="element-149">
              <p className="text-xl md:text-2xl font-medium leading-tight text-navy/80" data-id="element-150">
                We build algorithmic brand identities using strict geometric
                principles and generative AI systems.
              </p>
            </div>

            <motion.button whileHover={{
            scale: 1.02,
            backgroundColor: '#0a1628',
            color: '#ffffff'
          }} whileTap={{
            scale: 0.98
          }} className="group bg-coral text-white px-8 py-4 text-lg font-bold tracking-wide flex items-center gap-4 transition-colors border-2 border-coral hover:border-navy" data-id="element-151">
              START PROJECT
              <ArrowDownRight className="w-6 h-6 group-hover:rotate-45 transition-transform duration-300" data-id="element-152" />
            </motion.button>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-12 left-1/2 -translate-x-1/2" animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} data-id="element-153">
        <div className="w-[2px] h-16 bg-navy/20 overflow-hidden" data-id="element-154">
          <div className="w-full h-1/2 bg-coral animate-slide-down" data-id="element-155" />
        </div>
      </motion.div>
    </section>;
}